<template>
  <layout-empty-page>
    <lead-modal ref="leadModal"/>
  </layout-empty-page>
</template>

<script>
import LeadModal from './LeadModal.vue'
import LayoutEmptyPage from '../../layouts/page/LayoutEmptyPage.vue'

export default {
  name: 'LeadPage',
  components: {
    LeadModal,
    LayoutEmptyPage
  },
  mounted() {
    if (this.$route.query.lead) {
      this.$refs.leadModal.openModal()
    }
  }
}
</script>